module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/1@2x_e93c4ceb1f028c324cd35318e884f8c4.png";